// extracted by mini-css-extract-plugin
module.exports = {"container":"DeliveryAddresses_container__4hHHd","shippingSection":"DeliveryAddresses_shippingSection___FLl3","billingSection":"DeliveryAddresses_billingSection__GQZ_8"};